import { type FeatureProps } from "src/models/types/userSettings.types";

export const APP_CONFIG = {
	appId: "insightsLive",
	companyName: "ScaleAQ",
	appName: "Insights Live",
	signalrHub: "uniteaq",
	accessArea: "insights-live",
	features: {
		home: {
			id: "home",
			enabled: true,
			path: "/",
			name: "COMMON:features.home",
			icon: "LargeHome",
			env: "prod",
			priority: "top",
			configurable: false,
			addToSideMenu: true,
		} as FeatureProps,
		settings: {
			id: "settings",
			enabled: true,
			path: "/settings",
			name: "COMMON:features.settings",
			icon: "LargeSettingsGlobal",
			env: "prod",
			priority: "bottom",
			configurable: true,
			addToSideMenu: true,
		} as FeatureProps,
	},
} as const;
